import { gql } from 'graphql-request';

export const CART_FRAGMENT = gql`
  fragment cartFragment on Cart {
    id
    checkoutUrl
    note
    buyerIdentity {
      email
      countryCode
    }
    cost {
      # The amount, before taxes and cart-level discounts, for the customer to pay.
      subtotalAmount {
        amount
        currencyCode
      }
      # The total amount for the customer to pay.
      totalAmount {
        amount
        currencyCode
      }
      # The tax amount for the customer to pay at checkout.
      totalTaxAmount {
        amount
        currencyCode
      }
    }
    # The attributes associated with the cart. Attributes are represented as key-value pairs.
    attributes {
      key
      value
    }
    discountAllocations {
      ... on CartCodeDiscountAllocation {
        code
        discountedAmount {
          amount
        }
        __typename
      }
      ... on CartAutomaticDiscountAllocation {
        title
        __typename
      }
    }
    discountCodes {
      applicable
      code
      __typename
    }
    lines(first: 250) {
      # A list of lines containing information about the items the customer intends to purchase.
      edges {
        node {
          id
          attributes {
            key
            value
          }
          merchandise {
            ... on ProductVariant {
              id
              sku
              title
              image {
                url
              }
              compareAtPrice {
                amount
                currencyCode
              }
              price {
                amount
                currencyCode
              }
              selectedOptions {
                name
                value
              }
              product {
                id
                title
                handle
                tags
                productType
              }
            }
          }
          quantity
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
            ... on CartAutomaticDiscountAllocation {
              discountedAmount {
                amount
                currencyCode
              }
              targetType
              title
              __typename
            }
            ... on CartCodeDiscountAllocation {
              code
              discountedAmount {
                amount
                currencyCode
              }
              targetType
              __typename
            }
          }
        }
      }
      __typename
    }
  }
`;

export default {};
